//import vue router
import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'
//import store vuex
import store from '@/store'
import { trackPageView } from '@/utils/analytics'
//define a routes
const routes = [
  {
    // Public credential verification page (replaces Accredible's hosted page).
    path: '/verify/:code',
    name: 'verify-credential',
    component: () =>
      import('@/views/verify/VerifyCredential.vue'),
    meta: {
      hideNavbar: true,
      hideFooter: true,
      title: 'Verifikasi Kredensial',
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () =>
      import('@/views/auth/Register.vue'),
    meta: {
      hideNavbar: false,
      hideFooter: true,
      title: 'Register',
    },
  },
  {
    path: '/:pathMatch(.*)',
    component: () =>
      import('@/views/404/404.vue'),
    meta: {
      hideNavbar: false,
      title: 'Page Not Found',
    },
  },
  {
    path: '/',
    name: 'home',
    component: () =>
      import('@/views/LandingPage.vue'),
    meta: {
      hideNavbar: false,
      title: 'Home',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/auth/Login.vue'),
    // component: () =>
    //     import( '@/views/auth/Login.vue'),
    meta: {
      hideNavbar: false,
      hideFooter: true,
      title: 'Login',
    },
  },
  {
    path: '/affiliate-login',
    name: 'affiliate-login',
    component: () =>
      import('@/views/auth/LoginAffiliate.vue'),
    meta: {
      hideNavbar: false,
      hideFooter: true,
      title: 'Login',
    },
  },
  {
    path: '/dilatih-insight',
    name: 'dilatih-insight',
    component: () =>
      import(
        '@/views/dilatih-insight/DilatihInsight.vue'
      ),
    meta: {
      hideNavbar: false,
      hideFooter: false,
      title: 'Dilatih Insight',
    },
  },
  {
    path: '/dilatih-workshop',
    name: 'dilatih-workshop',
    component: () =>
      import(
        '@/views/dilatih-workshop/DilatihWorkshop.vue'
      ),
    meta: {
      hideNavbar: false,
      hideFooter: false,
      title: 'Dilatih Workshop',
    },
  },
  {
    path: '/sertifikasi-bnsp',
    name: 'sertifikasi-bnsp',
    component: () =>
      import(
        '@/views/sertifikasi-bnsp/SertifikasiBnsp.vue'
      ),
    meta: {
      hideNavbar: false,
      hideFooter: false,
      title: 'Sertifikasi BNSP',
    },
  },
  {
    path: '/dilatih-workshop/:id_event',
    name: 'workshop',
    component: () =>
      import(
        '@/views/dilatih-insight/workshop/WorkShop.vue'
      ),
    meta: {
      hideNavbar: false,
      hideFooter: false,
      title: 'Dilatih Insight',
    },
  },
  {
    path: '/registrasi-pembayaran/:email',
    name: 'payment-register',
    component: () =>
      import(
        '@/ui-components/berhasil-daftar-event-tanpa-akun.vue'
      ),
    meta: {
      requiresAuth: false,
      hideNavbar: true,
      hideSideBarAdmin: true,
      hideFooter: true,
      title: 'Registrasi Pembayaran',
      analyticsPath: '/registrasi-pembayaran/:email', // the address must not reach GA
    },
  },
  {
    path: '/dilatih-workshop/register/:id_event',
    name: 'workshop-register',
    component: () =>
      import(
        '@/views/dilatih-insight/workshop/WorkShopRegister.vue'
      ),
    meta: {
      hideNavbar: false,
      hideFooter: true,
      title: 'Dilatih Insight',
    },
  },
  {
    path: '/dilatih-insight/:id_event',
    name: 'dilatih-insight-detail',
    component: () =>
      import(
        '@/views/dilatih-insight/DilatihInsightDetail.vue'
      ),
    meta: {
      hideNavbar: false,
      hideFooter: false,
      title: 'Dilatih Insight Detail',
    },
  },
  {
    path: '/preview',
    name: 'preview',
    component: () =>
      import(
        '@/views/dilatih-insight/Preview.vue'
      ),
    meta: {
      hideNavbar: false,
      hideFooter: false,
      title: 'Preview',
    },
  },
  {
    path: '/dilatih-insight/register/:id_event',
    name: 'webinar-register',
    component: () =>
      import(
        '@/views/dilatih-insight/webinar/WebinarRegister.vue'
      ),
    meta: {
      hideNavbar: false,
      hideFooter: true,
      title: 'Webinar Register',
    },
  },
  {
    path: '/:id_event',
    name: 'webinar-register-short',
    component: () =>
      import(
        '@/views/dilatih-insight/webinar/WebinarRegister.vue'
      ),
    meta: {
      hideNavbar: false,
      hideFooter: true,
      title: 'Webinar Register ',
    },
  },
  {
    // The former "Dilatih for Corporate" page merged into /in-house-training (owner 2026-10-31); nginx also 301s it.
    path: '/partnership',
    name: 'partnership',
    redirect: '/in-house-training',
  },
  {
    path: '/in-house-training',
    name: 'in-house-training',
    component: () =>
      import(
        '@/views/landing-page/InHouseTraining.vue'
      ),
    meta: {
      hideNavbar: false,
      hideFooter: false,
      title: 'In-House Training Audit, Risk, IT, Data & AI',
    },
  },
  {
    path: '/blog',
    name: 'blog',
    component: () =>
      import(
        '@/views/landing-page/blog/Blog.vue'
      ),
    meta: {
      hideNavbar: false,
      hideFooter: false,
      title: 'Dilatih Blog',
    },
  },
  {
    path: '/blog/:slug',
    name: 'blog-detail',
    component: () =>
      import(
        '@/views/landing-page/blog/BlogDetail.vue'
      ),
    meta: {
      hideNavbar: false,
      hideFooter: false,
      title: 'Dilatih Blog',
    },
  },
  {
    path: '/penulis/:slug',
    name: 'penulis',
    component: () =>
      import(
        '@/views/landing-page/penulis/AuthorPage.vue'
      ),
    meta: {
      hideNavbar: false,
      hideFooter: false,
      title: 'Penulis',
    },
  },
  {
    path: '/promo-diskon',
    name: 'prodis',
    component: () =>
      import(
        '@/views/landing-page/PromoDiskon.vue'
      ),
    meta: {
      hideNavbar: false,
      hideFooter: false,
      title: 'Dilatih Promo & Diskon',
    },
  },
  {
    path: '/about-us',
    name: 'about-us',
    component: () =>
      import(
        '@/views/landing-page/AboutUs.vue'
      ),
    meta: {
      hideNavbar: false,
      hideFooter: false,
      title: 'Tentang Kami',
    },
  },
  {
    path: '/courses',
    name: 'course',
    component: () =>
      import('@/views/landing-page/Course.vue'),
    meta: {
      hideNavbar: false,
      hideFooter: false,
      title: 'Courses',
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () =>
      import(
        '@/views/admin/dashboard/Dashboard.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Dashboard',
    },
  },
  {
    path: '/user/dilatih-insight',
    name: 'user-dilatih-insight',
    component: () =>
      import(
        '@/views/admin/dilatih-insight/DilatihInsight.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Dilatih Insight',
    },
  },
  {
    path: '/user/dilatih-workshop',
    name: 'user-dilatih-workshop',
    component: () =>
      import(
        '@/views/admin/dilatih-workshop/DilatihWorkshop.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Dilatih Workshop',
    },
  },
  {
    path: '/user/dilatih-workshop/quiz/:id',
    name: 'user-quiz',
    component: () =>
      import('@/views/admin/quiz/Quiz.vue'),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      hideSideBarAdmin: true,
      title: 'Quiz',
    },
  },
  {
    path: '/user/dilatih-workshop/quiz/post-test/:id/:id_aktifitas/:isCoba',
    name: 'user-post-quiz',
    component: () =>
      import('@/views/admin/quiz/PostQuiz.vue'),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      hideSideBarAdmin: true,
      hideNavBarAdmin: true,
      title: 'Final Assesment',
    },
  },
  {
    path: '/user/dilatih-workshop/quiz/pre-test/:id/:id_aktifitas/:isCoba',
    name: 'user-pre-quiz',
    component: () =>
      import('@/views/admin/quiz/PreQuiz.vue'),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      hideSideBarAdmin: true,
      hideNavBarAdmin: true,
      title: 'Knwoledge Check',
    },
  },
  {
    path: '/transaksi/:id/:id_transaksi',
    name: 'transaction-detail',
    component: () =>
      import(
        '@/views/admin/transaction/TransactionDetail.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Transaksi Detail',
    },
  },
  {
    path: '/transaksi',
    name: 'transaction',
    component: () =>
      import(
        '@/views/admin/transaction/Transaction.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Transaksi',
    },
  },
  {
    path: '/aktifitas-event',
    name: 'other-activity',
    component: () =>
      import(
        '@/views/admin/other-activity/OtherActivity.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Aktifitas Lain',
    },
  },
  {
    path: '/aktifitas-lain/progress/:id/:id_aktifitas',
    name: 'progress',
    component: () =>
      import(
        '@/views/admin/progress/Progress.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Progress',
    },
  },
  {
    path: '/aktifitas-lain/progress-mini-workshop/:id/:id_aktifitas',
    name: 'progress-mini-workshop',
    component: () =>
      import(
        '@/views/admin/progress/ProgressMiniWorkshop.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Progress Mini Workshop',
    },
  },
  {
    path: '/aktifitas-lain/progress-workshop/:id/:id_aktifitas',
    name: 'progress-workshop',
    component: () =>
      import(
        '@/views/admin/progress/Workshop.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Progress Workshop',
    },
  },
  {
    path: '/aktifitas-lain/progress/learning-roadmap',
    name: 'roadmap',
    component: () =>
      import(
        '@/views/admin/roadmap/RoadMap.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Learning Rodmap',
    },
  },
  {
    path: '/profile-pengguna',
    name: 'profile-pengguna',
    component: () =>
      import(
        '@/views/admin/profile/Profilepengguna.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Profile Pengguna',
    },
  },
  {
    path: '/sertifikat',
    name: 'certificate',
    component: () =>
      import(
        '@/views/admin/certificate/Certificate.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Sertifikat',
    },
  },
  {
    path: '/sertifikat-webinar/:id',
    name: 'certificate-show-webinar',
    component: () =>
      import(
        '@/views/admin/certificate/CertificateShowWebinar.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Sertifikat Webinar',
    },
  },
  {
    path: '/sertifikat-webinar/share/:id',
    name: 'certificate-show-webinar-share',
    component: () =>
      import(
        '@/views/admin/certificate/share/CertificateShowWebinarShare.vue'
      ),
    meta: {
      requiresAuth: false,
      hideNavbar: false,
      hideFooter: true,
      hideSideBarAdmin: true,
      title: 'Sertifikat Webinar',
    },
  },
  {
    path: '/sertifikat-workshop/:id',
    name: 'certificate-show-workshop',
    component: () =>
      import(
        '@/views/admin/certificate/CertificateShowWorkshop.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Sertifikat Workshop',
    },
  },
  {
    path: '/sertifikat-workshop/share/:id',
    name: 'certificate-show-workshop-share',
    component: () =>
      import(
        '@/views/admin/certificate/share/CertificateShowWorkshopShare.vue'
      ),
    meta: {
      requiresAuth: false,
      hideNavbar: false,
      hideFooter: true,
      hideSideBarAdmin: true,
      title: 'Sertifikat Workshop',
    },
  },
  {
    path: '/notifikasi',
    name: 'notification',
    component: () =>
      import(
        '@/views/admin/notification/Notification.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Notifikasi',
    },
  },
  {
    path: '/admin/dashboard',
    name: 'admin-dashboard',
    component: () =>
      import(
        '@/views/admin_cms/dashboard/Dashboard.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Dashboard',
    },
  },
  {
    path: '/admin/landing-page',
    name: 'admin-landing-page',
    component: () =>
      import(
        '@/views/admin_cms/landingpage/LandingPage.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'CMS Landing Page',
    },
  },
  {
    path: '/admin/landing-page/promo/:id_promo',
    name: 'admin-landing-page-promo-detail',
    component: () =>
      import(
        '@/views/admin_cms/landingpage/PromoDetail.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Promo',
    },
  },
  {
    path: '/admin/insight',
    name: 'admin-insight',
    component: () =>
      import(
        '@/views/admin_cms/insight/Insight.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Dilatih Insight',
    },
  },
  {
    path: '/admin/insight/produk',
    name: 'admin-insight-produk',
    component: () =>
      import(
        '@/views/admin_cms/insight/product/InsightWebinar.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Produk Insight',
    },
  },
  {
    path: '/admin/insight/settings',
    name: 'admin-insight-settings',
    component: () =>
      import(
        '@/views/admin_cms/insight/CmsSettings.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Insight CMS Settings',
    },
  },
  {
    path: '/admin/insight/webinar/add',
    name: 'admin-insight-webinar-add',
    component: () =>
      import(
        '@/views/admin_cms/insight/product/WebinarAdd.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Tambah Produk Insight',
    },
  },
  {
    path: '/admin/insight/webinar/edit/:id_event',
    name: 'admin-insight-webinar-edit',
    component: () =>
      import(
        '@/views/admin_cms/insight/product/WebinarEdit.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Edit Produk Insight',
    },
  },
  {
    path: '/admin/insight/webinar/:id_event',
    name: 'admin-insight-webinar',
    component: () =>
      import(
        '@/views/admin_cms/insight/product/WebinarDetail.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Dilatih Insight Detail',
    },
  },

  {
    path: '/admin/workshop/product',
    name: 'admin-workshop-product',
    component: () =>
      import(
        '@/views/admin_cms/workshop/product/InsightWorkshop.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Produk Workshop',
    },
  },
  {
    path: '/admin/workshop/add',
    name: 'admin-workshop-add',
    component: () =>
      import(
        '@/views/admin_cms/workshop/product/WorkshopAdd.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Tambah Produk Workshop',
    },
  },
  {
    path: '/admin/workshop/:id_event',
    name: 'admin-workshop-detail',
    component: () =>
      import(
        '@/views/admin_cms/workshop/product/WorkshopDetail.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Dilatih Workshop Detail',
    },
  },
  {
    path: '/admin/workshop/add-batch/:id_event/:jenis_produk',
    name: 'admin-workshop-add-batch',
    component: () =>
      import(
        '@/views/admin_cms/workshop/product/WorkshopAddBatch.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Tambah Batch Workshop',
    },
  },
  {
    path: '/admin/workshop/edit-batch/:id_event/:jenis',
    name: 'admin-workshop-edit-batch',
    component: () =>
      import(
        '@/views/admin_cms/workshop/product/WorkshopEditBatch.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Edit Batch Workshop',
    },
  },
  {
    path: '/admin/workshop/edit/:id_event',
    name: 'admin-workshop-edit',
    component: () =>
      import(
        '@/views/admin_cms/workshop/product/WorkshopEdit.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Edit Workshop Produk',
    },
  },
  {
    path: '/admin/workshop',
    name: 'admin-workshop',
    component: () =>
      import(
        '@/views/admin_cms/workshop/Workshop.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Dilatih Workshop',
    },
  },
  {
    path: '/admin/workshop/settings',
    name: 'admin-workshop-settings',
    component: () =>
      import(
        '@/views/admin_cms/workshop/CmsSettings.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Workshop CMS Settings',
    },
  },
  {
    path: '/admin/class',
    name: 'admin-class',
    component: () =>
      import(
        '@/views/admin_cms/class/Class.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Dilatih Class',
    },
  },
  {
    path: '/admin/partnership',
    name: 'admin-partnership',
    component: () =>
      import(
        '@/views/admin_cms/partner/Partner.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Dilatih Partnership',
    },
  },
  {
    path: '/admin/about',
    name: 'admin-about',
    component: () =>
      import(
        '@/views/admin_cms/about/About.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'About Dilatih',
    },
  },
  {
    path: '/admin/blog',
    name: 'admin-blog',
    component: () =>
      import('@/views/admin_cms/blog/Blog.vue'),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Dilatih Blog',
    },
  },
  {
    path: '/admin/blog/new',
    name: 'admin-blog-new',
    component: () =>
      import(
        '@/views/admin_cms/blog/BlogForm.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Tulis Artikel Baru',
    },
  },
  {
    path: '/admin/blog/edit/:id',
    name: 'admin-blog-edit',
    component: () =>
      import(
        '@/views/admin_cms/blog/BlogForm.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Edit Artikel',
    },
  },
  {
    path: '/admin/user-management',
    name: 'admin-management',
    component: () =>
      import(
        '@/views/admin_cms/user-management/UserManagement.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'User Management',
    },
  },
  {
    path: '/admin/affiliate',
    name: 'admin-affiliate',
    component: () =>
      import(
        '@/views/admin_cms/affiliate/Affiliate.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Affiliate Settings',
    },
  },
  {
    path: '/admin/affiliate/:id_affiliate',
    name: 'admin-affiliate-detail',
    component: () =>
      import(
        '@/views/admin_cms/affiliate/AffiliateDetail.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Affiliate Detail',
    },
  },
  {
    path: '/admin/payment-report',
    name: 'admin-payment',
    component: () =>
      import(
        '@/views/admin_cms/payment/Payment.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Payment & Report',
    },
  },
  {
    path: '/admin/notification-newsletter',
    name: 'admin-notif',
    component: () =>
      import(
        '@/views/admin_cms/notif/Notif.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Notification / Newsletter',
    },
  },
  {
    path: '/admin/system-settings',
    name: 'admin-settings',
    component: () =>
      import(
        '@/views/admin_cms/settings/Settings.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'System Settings',
    },
  },
  {
    // Apps behind the SSO gate (n8n, WAHA) send visitors here; see SsoRedirect.vue.
    path: '/admin/sso/:app',
    name: 'admin-sso',
    component: () => import('@/views/admin_cms/sso/SsoRedirect.vue'),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Membuka aplikasi',
    },
  },
  {
    path: '/admin/leads',
    name: 'admin-leads',
    component: () =>
      import(
        '@/views/admin_cms/leads/LeadsDashboard.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Sales Leads / BI',
    },
  },
  {
    path: '/admin/pmli',
    name: 'admin-pmli',
    component: () => import('@/views/admin_cms/pmli/PmliIntegration.vue'),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Integrasi PMLI',
    },
  },
  {
    path: '/admin/backup',
    name: 'admin-backup',
    component: () =>
      import(
        '@/views/admin_cms/backup/BackUp.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Back Up',
    },
  },
  {
    path: '/admin/kelola-webinar',
    name: 'kelola-webinar',
    component: () =>
      import(
        '@/views/admin_cms/webinar/Webinar.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Kelola Webinar',
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () =>
      import('@/views/auth/ForgetPassword.vue'),
    meta: {
      requiresAuth: false,
      hideNavbar: false,
      title: 'Forget Password',
    },
  },
  {
    path: '/forget-password/confirm-new-password/:uuid',
    name: 'confirm-new-password',
    component: () =>
      import(
        '@/views/auth/ConfirmPassword.vue'
      ),
    meta: {
      requiresAuth: false,
      hideNavbar: false,
      title: 'Confirm New Password',
      analyticsPath: '/forget-password/confirm-new-password/:uuid', // the reset token must not reach GA
    },
  },
  {
    path: '/affiliate/dashboard',
    name: 'affiliate-dashboard',
    component: () =>
      import(
        '@/views/affiliate/dashboard/Dashboard.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Dashboard',
    },
  },
  {
    path: '/affiliate/produk',
    name: 'affiliate-product',
    component: () =>
      import(
        '@/views/affiliate/product/Product.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Produk',
    },
  },
  {
    path: '/affiliate/promo/:id_promo',
    name: 'affiliate-promo-detail',
    component: () =>
      import(
        '@/views/affiliate/product/product_detail/PromoDetail.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Promo',
    },
  },
  {
    path: '/affiliate/produk/:id_event/:id_batch',
    name: 'affiliate-product-detail',
    component: () =>
      import(
        '@/views/affiliate/product/product_detail/ProductDetail.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Produk',
    },
  },
  {
    path: '/affiliate/transaksi',
    name: 'affiliate-transaction',
    component: () =>
      import(
        '@/views/affiliate/transaction/Transaction.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Transaksi',
    },
  },
  {
    path: '/affiliate/pembayaran',
    name: 'affiliate-payment',
    component: () =>
      import(
        '@/views/affiliate/payment/Payment.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Pembayaran',
    },
  },
  {
    path: '/affiliate/profile',
    name: 'affiliate-profile',
    component: () =>
      import(
        '@/views/affiliate/profile/Profile.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Profile',
    },
  },
  {
    path: '/privacy-policy',
    alias: '/kebijakan-privasi',
    name: 'privacy',
    component: () =>
      import(
        '@/views/privacy_policy/PrivacyPolicy.vue'
      ),
    meta: {
      requiresAuth: false,
      hideSideBarAdmin: true,
      title: 'Kebijakan Privasi',
    },
  },
  {
    // Unsubscribe link in marketing emails (token in the #fragment)
    path: '/berhenti-berlangganan',
    name: 'unsubscribe',
    component: () => import('@/views/unsubscribe/Unsubscribe.vue'),
    meta: {
      requiresAuth: false,
      title: 'Berhenti Berlangganan',
    },
  },
  {
    path: '/terms-of-service',
    alias: '/syarat-ketentuan',
    name: 'termsofservice',
    component: () =>
      import(
        '@/views/terms_service/TermsService.vue'
      ),
    meta: {
      requiresAuth: false,
      hideSideBarAdmin: true,
      title: 'Syarat dan Ketentuan',
    },
  },

  {
    path: '/404',
    name: 'Not Found',
    component: () =>
      import('@/views/404/404.vue'),
    meta: {
      requiresAuth: false,
      hideNavbar: true,
      title: 'Not Found',
    },
  },
  {
    path: '/tiket/:id',
    name: 'ambilsertifikat',
    component: () =>
      import('@/components/Loading.vue'),
    meta: {
      requiresAuth: false,
      hideNavbar: true,
      title: 'Ambil Sertifikat',
    },
  },
  {
    path: '/trainer/dashboard',
    name: 'trainer-dashboard',
    component: () =>
      import(
        '@/views/trainer/dashboard/Dashboard.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Dashboard',
    },
  },
  {
    path: '/trainer/schedule',
    name: 'trainer-schedule',
    component: () =>
      import(
        '@/views/trainer/schedule/Schedule.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Jadwal',
    },
  },
  {
    path: '/trainer/payment',
    name: 'trainer-payment',
    component: () =>
      import(
        '@/views/trainer/payment/Payment.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Payment & Report',
    },
  },
  {
    path: '/trainer/event',
    name: 'trainer-event',
    component: () =>
      import('@/views/trainer/event/Event.vue'),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Event',
    },
  },
  {
    path: '/trainer/portal-penilaian',
    name: 'trainer-portal',
    component: () =>
      import(
        '@/views/trainer/portal/PortalPenilaian.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Portal Penilaian',
    },
  },
  {
    path: '/trainer/event/:id/:id_batch',
    name: 'trainer-event-detail',
    component: () =>
      import(
        '@/views/trainer/event/event-detail/EventDetail.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Event Detail',
    },
  },
  {
    path: '/trainer/event/:id/materi',
    name: 'trainer-event-detail-materi',
    component: () =>
      import(
        '@/views/trainer/event/event-detail/EventDetailMateri.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Event Materi & Soal',
    },
  },
  {
    path: '/trainer/event/:id/materi/soal',
    name: 'trainer-event-detail-materi-soal',
    component: () =>
      import(
        '@/views/trainer/event/event-detail/EventDetailMateriSoal.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Event Soal',
    },
  },
  {
    path: '/trainer/event/:id/materi/kasus',
    name: 'trainer-event-detail-materi-kasus',
    component: () =>
      import(
        '@/views/trainer/event/event-detail/EventDetailMateriKasus.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Event Soal Studi Kasus',
    },
  },
  {
    path: '/trainer/profile',
    name: 'trainer-profile',
    component: () =>
      import(
        '@/views/trainer/profile/Profile.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: false,
      title: 'Profile',
    },
  },
  {
    path: '/testingcapture',
    name: 'testingcapture',
    component: () =>
      import('@/views/Testing.vue'),
    meta: {
      requiresAuth: true,
      hideNavbar: true,
      // hideSideBarAdmin: true,
      title: 'Profile',
    },
  },
  {
    path: '/testingcaptureworkshop',
    name: 'testingcaptureworkshop',
    component: () =>
      import('@/views/TestingWorkshop.vue'),
    meta: {
      requiresAuth: true,
      hideNavbar: true,
      // hideSideBarAdmin: true,
      title: 'Profile',
    },
  },
  {
    path: '/testingcaptureworkshopjp',
    name: 'testingcaptureworkshopjp',
    component: () =>
      import('@/views/TestingWorkshopJp.vue'),
    meta: {
      requiresAuth: true,
      hideNavbar: true,
      // hideSideBarAdmin: true,
      title: 'Profile',
    },
  },
  {
    path: '/generate-jp-certificate/:id_aktifitas',
    name: 'generatejpcertificate',
    component: () =>
      import('@/views/TestingWorkshopJp.vue'),
    meta: {
      requiresAuth: true,
      hideNavbar: true,
      // hideSideBarAdmin: true,
      title: 'memuat sertifikat Jam Pembelajaran',
    },
  },
  {
    path: '/peserta-kuis',
    name: 'pesertakuis',
    props: (route) => ({
      id_event: route.query.id_event,
      id_batch: route.query.id_batch,
    }),
    component: () =>
      import(
        '@/views/admin_cms/workshop/product/WorkshopPesertaKuis.vue'
      ),
    meta: {
      requiresAuth: true,
      hideNavbar: true,
      // hideSideBarAdmin: true,
      title: 'Peserta Kuis',
    },
  },
]

//create router
const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'side-active',
})

const DEFAULT_TITLE = 'dilatih.co'
//define route for handle authentication
router.beforeEach((to, from, next) => {
  // window.scrollTo(0, 0)
  document.title = to.meta.title + ' | dilatih.co' || DEFAULT_TITLE

  // role 7 (BI Leads) is locked to the leads tab — block every other admin page
  try {
    const profile = JSON.parse(window.localStorage.getItem('user')) || {}
    if (
      Number(profile.id_role) === 7 &&
      to.path.startsWith('/admin') &&
      to.name !== 'admin-leads' &&
      to.name !== 'admin-sso'
    ) {
      next({ name: 'admin-leads' })
      return
    }
  } catch (e) {
    // corrupt/missing profile — fall through to the normal auth checks
  }

  if (to.name === 'admin-sso' && store.getters['auth/isLoggedIn'] == '') {
    // Not logged in yet: come back to this app after logging in (Login.vue).
    window.sessionStorage.setItem('after_login', to.fullPath)
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (window.localStorage.getItem('ip')) {
      //cek nilai dari getters isLoggedIn di module auth
      if (store.getters['auth/isLoggedIn'] != '') {
        if (to.fullPath.includes('%3F')) {
          let fullPath = to.fullPath.replace('%3F', '?')
          next(fullPath)
        } else {
          next()
        }
      }
      next('/login')
      return
    } else {
      let url = process.env.VUE_APP_API_GET_API
      axios
        .get(url)
        .then((response) => {
          localStorage.setItem('ip', response.data.ip)
        })
        .catch((error) => {
          console.log(error)
        })

      //cek nilai dari getters isLoggedIn di module auth
      if (store.getters['auth/isLoggedIn'] != '') {
        if (to.fullPath.includes('%3F')) {
          let fullPath = to.fullPath.replace('%3F', '?')
          next(fullPath)
        } else {
          next()
        }
        return
      }
      next('/login')
    }
  } else {
    if (window.localStorage.getItem('ip')) {
      if (to.fullPath.includes('%3F')) {
        let fullPath = to.fullPath.replace('%3F', '?')
        next(fullPath)
      } else {
        next()
      }
      return
    } else {
      let url = process.env.VUE_APP_API_GET_API
      axios
        .get(url)
        .then((response) => {
          localStorage.setItem('ip', response.data.ip)
        })
        .catch((error) => {
          console.log(error)
        })
    }
    if (to.fullPath.includes('%3F')) {
      let fullPath = to.fullPath.replace('%3F', '?')
      next(fullPath)
    } else {
      next()
    }
  }
})

// SPA page-view tracking on every successful navigation.
// (GA4 `purchase` is fired server-side from the Xendit PAID webhook — not here.)
// Never the #fragment (it carries the unsubscribe token), and a route with meta.analyticsPath reports that
// pattern instead of its real path (tokens, email addresses).
router.afterEach((to) => {
  trackPageView((to.meta && to.meta.analyticsPath) || to.fullPath.split('#')[0], to.meta && to.meta.title)
})

// A tab opened before a deploy can ask for a page chunk of the previous build. If it is gone (or a 404 for it
// was cached), the navigation failed silently: Edit Batch and the test pages "did nothing" (2026-11-03).
// Reload once on the target URL so the browser fetches the current index.html and bundles.
router.onError((error, to) => {
  const msg = String((error && error.message) || error || '')
  if (!/Loading (CSS )?chunk|ChunkLoadError|dynamically imported module|Importing a module script failed/i.test(msg)) return
  try {
    const key = 'chunk_reload_at'
    const last = Number(window.sessionStorage.getItem(key) || 0)
    if (Date.now() - last < 10000) return // already reloaded just now: do not loop
    window.sessionStorage.setItem(key, String(Date.now()))
  } catch (e) {
    /* storage blocked: reload anyway */
  }
  window.location.assign(to && to.fullPath ? to.fullPath : window.location.href)
})

export default router
